import { TFunction } from 'i18next';
import {
  ValidationError,
  EValidationSeverity,
} from 'components/ui/excel-table/types';
import { BindingRow } from './types';
import { isNil } from 'lodash';

export const validateBindingRow = (
  row: BindingRow,
  rowIndex: number,
  allRows: BindingRow[],
  t: TFunction
): ValidationError<BindingRow>[] => {
  const errors: ValidationError<BindingRow>[] = [];

  if (row.isGroupRow || row.isAddRow) {
    return errors;
  }

  // Check for duplicate contracts within the same layer
  if (row.layerNumber && row.reinsured && row.sourceBroker && row.binder) {
    const duplicateRows = allRows.filter(
      (r) =>
        !r.isGroupRow &&
        !r.isAddRow &&
        r.id !== row.id &&
        r.layerNumber === row.layerNumber &&
        r.reinsured === row.reinsured &&
        r.sourceBroker === row.sourceBroker &&
        r.binder === row.binder
    );

    if (duplicateRows.length > 0) {
      errors.push({
        field: 'binder',
        rowIndex,
        message: t('binderDeployment.duplicateContract'),
        severity: EValidationSeverity.SOFT,
      });
    }
  }

  // Check if total binder share exceeds 100%
  if (row.binderShareQuoted && row.layerNumber) {
    const layerRows = allRows.filter(
      (r) => r.layerNumber === row.layerNumber && !r.isGroupRow && !r.isAddRow
    );

    const totalShareInLayer = layerRows.reduce(
      (sum, r) => sum + (r.binderShareQuoted || 0),
      0
    );

    if (totalShareInLayer > 100) {
      errors.push({
        field: 'binderShareQuoted',
        rowIndex,
        message: t('binderDeployment.binderShareExceeds100'),
        severity: EValidationSeverity.SOFT,
      });
    }
  }

  // Check if total binder share exceeds 100%
  if (row.binderShareSigned && row.layerNumber) {
    const layerRows = allRows.filter(
      (r) => r.layerNumber === row.layerNumber && !r.isGroupRow && !r.isAddRow
    );

    const totalShareInLayer = layerRows.reduce(
      (sum, r) => sum + (r.binderShareSigned || 0),
      0
    );

    if (totalShareInLayer > 100) {
      errors.push({
        field: 'binderShareSigned',
        rowIndex,
        message: t('binding.binderShareExceeds100'),
        severity: EValidationSeverity.SOFT,
      });
    }
  }

  // Strict validation - will prevent syncing to backend
  if (
    !isNil(row.binderShareSigned) &&
    (row.binderShareSigned < 0 || row.binderShareSigned > 100)
  ) {
    errors.push({
      field: 'binderShareSigned',
      rowIndex,
      message: t('binding.binderShareSignedInvalid'),
      severity: EValidationSeverity.STRICT,
    });
  }

  return errors;
};
